<template>
  <div class="step2">
    <a-spin :spinning="spinning">
      <div class="step2_body">
        <div class="step2_head">
          <div class="step3_upload">
            <span v-if="ct.file_path2"
              >保函:
              <a class="mr-2 text-sky-500" @click="preview(0)">预览</a>
              <a @click="Download(1)" class="text-sky-500">下载</a>
            </span>
          </div>
          <div class="step3_upload"
            ><span v-if="ct.file_path"
              >合同:
              <a class="mr-2 text-sky-500" @click="preview(1)">预览</a>
              <a @click="Download(0)" class="text-sky-500">下载</a>
            </span></div
          >
          <a-divider>请签章后上传合同</a-divider>
          <Upload @upload="qUpload" :ct="ct"></Upload>
          <div class="flex flex-col items-end mt-8">
            <a-divider>保函详情</a-divider>
            <a-descriptions :column="2" :bordered="false">
              <a-descriptions-item label="项目名称" span="2">{{ ct.project }}</a-descriptions-item>
              <a-descriptions-item label="保函编号" span="2">{{
                ct.prefix + ct.code
              }}</a-descriptions-item>
              <a-descriptions-item label="保证金额">¥{{ ct.poundage }}</a-descriptions-item>
              <a-descriptions-item label="申请时间">{{ ct.create_time }}</a-descriptions-item>
            </a-descriptions>
            <div class="flex mr-10">
              <div class="pr-5 w-30"
                ><a-button type="primary" @click="saveSignFile()">保存</a-button></div
              >
              <div><a-button type="primary" @click="handleSubmit()">下一步</a-button></div>
            </div>
          </div>
        </div>
      </div>
    </a-spin>
    <a-modal
      :visible="previewflag"
      title="预览"
      :footer="null"
      @cancel="previewflag = false"
      width="1000px"
    >
      <iframe
        :src="`${$ossUrl}/pdfjs/build/web/viewer.html?file=${$ossUrl}${ct.file_path2}`"
        style="width: 100%; height: 60vh"
      ></iframe>
    </a-modal>
    <a-modal
      :visible="previewflag2"
      title="预览"
      :footer="null"
      @cancel="previewflag2 = false"
      width="1000px"
    >
      <iframe
        :src="`${$ossUrl}/pdfjs/build/web/viewer.html?file=${$ossUrl}${ct.file_path}`"
        style="width: 100%; height: 60vh"
      ></iframe>
    </a-modal>
  </div>
</template>
<script>
  import Upload from '@/components/ConMultUpload/index';
  import { download } from '@/utils/download';
  import { saveSignRdis, stepSignContent } from '@/api/contract';
  export default {
    components: {
      Upload,
    },
    props: {
      ct: {
        type: Object,
        default: () => {},
      },
    },
    data() {
      return {
        setting: {},
        banklist: [],
        company: {},
        info: {},
        spinning: false,
        previewflag: false,
        previewflag2: false,
      };
    },
    async mounted() {},
    computed: {},
    watch: {
      ct(a) {
        Object.assign(this.info, a);
        console.log(123);
      },
    },
    methods: {
      preview(isflie) {
        if (isflie) {
          this.previewflag2 = true;
        } else {
          this.previewflag = true;
        }
      },
      async Download(isflie) {
        this.spinning = true;
        await download(this.ct, isflie);
        await download(this.ct, isflie);
        this.spinning = false;
      },
      qUpload(res) {
        console.log(this.info.id);
        this.info.sign_file_r_ids = res
          .map((v) => {
            return v.uid;
          })
          .join(',');
        console.log(this.info.sign_file_r_ids);
        // this.setTimeout(() => this.form.setFieldsValue({ qualification_src: res.pathname }), 1);
      },
      async handleSubmit(e) {
        console.log(1332);
        try {
          this.spinning = true;
          await stepSignContent(this.info);
          this.$emit('next', this.ct);
        } catch (error) {
          this.$message.error(error);
        } finally {
          this.spinning = false;
        }
      },
      async saveSignFile() {
        try {
          this.spinning = true;
          await saveSignRdis(this.info);
          this.$router.push(`/admin/contract`);
        } catch (error) {
          this.$message.error(error);
        } finally {
          this.spinning = false;
        }
      },
    },
  };
</script>
<style lang="less" scoped>
  .step2 {
    display: block;
    width: 900px;
    margin: 0 auto;
  }
  .step2_body {
    margin-bottom: 20px;
    background-color: #fff;
    border: 1px solid transparent;
    border-radius: 4px;
  }
  .step2_head {
    color: #4e5969;
    font-weight: bold;
    background-color: #f6f6f8;
    border-color: #f6f6f8;
    padding: 11px 15px;
    border-top-left-radius: 3px;
    border-top-right-radius: 3px;
    border-bottom: 1px solid transparent;
  }
  .heng {
    padding-left: 10px;
    position: relative;
    color: #4e5969;
    font-weight: bold;
    font-size: 16px;
  }
  .heng ::before {
    content: '';
    display: inline-block;
    position: absolute;
    width: 4px;
    left: -4px;
    height: 100%;
    background-color: #f6384c;
  }

  .step3_upload {
    display: flex;

    align-items: center;
  }
</style>
@/components/ConMultUpload/index
